import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1280.000000 1280.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M9538 8029 c-190 -28 -377 -116 -510 -242 -50 -46 -56 -63 -37 -100
26 -49 74 -50 126 -4 77 68 124 99 206 137 290 136 612 92 865 -120 65 -55
106 -64 135 -32 33 36 22 76 -37 129 -197 181 -487 271 -748 232z"
          />
          <path
            d="M3475 7624 c-165 -97 -336 -197 -380 -223 -44 -26 -129 -76 -190
-111 -60 -35 -118 -70 -127 -78 -16 -14 -18 -40 -18 -274 0 -211 2 -258 14
-258 7 0 71 33 142 74 71 40 287 163 479 273 193 110 360 206 373 214 22 14
22 15 22 286 0 150 -3 273 -7 273 -5 0 -143 -79 -308 -176z"
          />
          <path
            d="M9568 7780 c-140 -25 -261 -81 -352 -161 -63 -57 -73 -93 -34 -129
33 -30 63 -25 124 25 102 84 236 135 354 135 119 0 266 -56 360 -136 28 -24
61 -44 71 -44 54 0 89 52 66 96 -17 33 -96 97 -171 139 -112 62 -301 96 -418
75z"
          />
          <path
            d="M9570 7526 c-66 -15 -130 -46 -187 -93 -36 -28 -43 -40 -43 -69 0
-41 29 -74 65 -74 13 0 40 14 59 30 111 98 262 102 385 10 30 -22 63 -40 73
-40 25 0 68 44 68 70 0 57 -135 147 -254 169 -72 13 -95 13 -166 -3z"
          />
          <path
            d="M9623 7259 c-48 -14 -73 -52 -73 -111 0 -41 5 -54 28 -78 80 -80 214
-18 199 92 -10 75 -78 118 -154 97z"
          />
          <path
            d="M3745 7053 c-61 -36 -716 -413 -1037 -597 l-178 -101 0 -287 c0 -209
3 -288 11 -288 7 0 35 14 63 32 28 17 67 40 86 51 19 11 168 98 330 195 162
96 405 240 540 320 135 80 253 152 263 160 15 14 17 40 17 284 0 308 7 292
-95 231z"
          />
          <path
            d="M4655 6872 c-209 -120 -535 -308 -725 -417 -190 -109 -360 -206 -378
-217 -56 -31 -82 -50 -82 -58 0 -5 30 -26 68 -47 37 -22 137 -81 223 -131 86
-51 164 -92 172 -92 9 0 38 13 65 29 26 15 68 39 93 53 24 14 118 67 209 118
244 138 264 150 273 150 4 0 7 -148 7 -330 0 -181 3 -330 8 -331 10 -1 445 -1
460 0 9 1 12 157 12 746 0 589 -3 745 -12 745 -7 0 -184 -99 -393 -218z"
          />
          <path
            d="M8443 6694 c-82 -29 -134 -116 -119 -198 13 -70 62 -106 195 -146 42
-12 84 -32 98 -46 23 -23 24 -27 10 -47 -8 -12 -26 -26 -40 -31 -38 -14 -124
9 -191 49 l-56 34 -25 -49 c-14 -27 -25 -56 -25 -63 0 -8 23 -26 51 -42 114
-62 257 -74 347 -29 72 36 102 82 102 154 0 99 -39 137 -186 185 -107 34 -141
63 -116 103 21 32 120 19 232 -32 12 -5 23 8 44 51 26 54 27 58 10 70 -64 47
-245 67 -331 37z"
          />
          <path
            d="M5420 6405 l0 -295 65 0 65 0 0 187 c0 103 4 183 8 178 5 -6 40 -76
78 -157 l69 -148 52 3 53 2 72 150 73 151 3 -183 2 -183 70 0 70 0 0 295 0
295 -86 0 -85 0 -82 -170 c-45 -93 -84 -170 -87 -170 -4 0 -44 77 -90 170
l-84 170 -83 0 -83 0 0 -295z"
          />
          <path
            d="M6401 6678 c-5 -13 -59 -140 -121 -283 -62 -143 -114 -266 -117 -272
-4 -10 15 -13 74 -13 l79 0 18 50 18 50 133 0 133 0 17 -50 17 -50 79 0 c43 0
79 3 79 8 0 4 -54 135 -120 292 l-119 285 -81 3 c-76 3 -81 2 -89 -20z m130
-246 l36 -97 -38 -3 c-21 -2 -58 -2 -82 0 l-44 3 40 103 c21 57 42 100 45 97
4 -3 23 -50 43 -103z"
          />
          <path
            d="M6870 6405 l0 -295 70 0 70 0 2 182 3 181 75 -151 74 -152 51 0 50 0
69 148 c39 81 73 151 78 157 4 5 8 -75 8 -178 l0 -187 65 0 65 0 0 295 0 295
-83 0 -84 0 -81 -170 c-45 -93 -85 -170 -89 -170 -5 0 -45 77 -90 170 l-82
170 -85 0 -86 0 0 -295z"
          />
          <path
            d="M7743 6412 c-68 -158 -123 -291 -123 -295 0 -4 33 -7 74 -7 l73 0 21
50 21 51 132 -3 131 -3 18 -45 18 -45 82 -3 c45 -2 80 1 78 6 -1 5 -57 138
-123 295 l-120 287 -80 0 -80 0 -122 -288z m277 -74 c0 -5 -36 -8 -80 -8 -44
0 -80 4 -80 8 0 8 24 71 67 172 l14 35 40 -100 c21 -55 39 -103 39 -107z"
          />
          <path
            d="M8860 6512 c0 -214 11 -269 63 -329 50 -57 116 -83 213 -83 130 0
211 52 249 159 11 33 15 90 15 242 l0 199 -75 0 -75 0 0 -185 c0 -200 -7 -238
-51 -269 -31 -21 -108 -21 -135 2 -44 35 -49 58 -52 260 l-4 192 -74 0 -74 0
0 -188z"
          />
          <path
            d="M9500 6405 l0 -297 198 4 c194 3 198 3 243 30 58 34 83 82 76 146 -6
53 -32 91 -75 112 -38 18 -39 23 -7 38 61 28 83 123 43 182 -45 65 -80 75
-290 78 l-188 4 0 -297z m324 162 c26 -19 24 -67 -4 -89 -19 -15 -37 -18 -94
-16 l-71 3 -3 58 -3 57 79 0 c49 0 85 -5 96 -13z m14 -233 c28 -19 29 -65 2
-89 -15 -14 -38 -18 -102 -19 l-83 -1 -3 63 -3 62 83 0 c59 0 90 -5 106 -16z"
          />
          <path
            d="M3245 6037 c-19 -13 -61 -36 -315 -170 -63 -33 -118 -66 -123 -71 -9
-14 -8 -319 2 -335 5 -8 69 -11 242 -9 l234 3 0 294 c0 191 -4 296 -10 298 -6
2 -19 -3 -30 -10z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
